import { render, staticRenderFns } from "./mailsidebar.vue?vue&type=template&id=7c8bb2e8"
import script from "./mailsidebar.vue?vue&type=script&lang=js"
export * from "./mailsidebar.vue?vue&type=script&lang=js"
import style0 from "./mailsidebar.vue?vue&type=style&index=0&id=7c8bb2e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports